const env = process.env.REACT_APP_ENV;
console.log("ENV:", env);

let api = {
    url: 'http://localhost:3001/svount-api'
}

let stytch = {
    publicToken: process.env.REACT_APP_STYTCH_TEST_PUBLIC_TOKEN
}

if (env === 'production') {
    api.url = process.env.REACT_APP_API_PRODUCTION_URL;
    stytch.publicToken = process.env.REACT_APP_STYTCH_LIVE_PUBLIC_TOKEN;
}

export default { api, stytch };